import styled from '@emotion/styled'
import { Container, Box } from 'theme-ui'

const SectionContainerStyled = styled(Box)`
  overflow: hidden;
`

const SectionInnerStyled = styled(Container)`
  margin: 0 auto;
  width: 100%;
`

const SectionStyled = styled(Box)``

const SectionHeadStyled = styled(Box)`
  max-width: 49.375rem;
  text-align: center;
  margin: 0 auto;
`

const SectionBodyStyled = styled(Box)``

export { SectionContainerStyled, SectionInnerStyled, SectionStyled, SectionHeadStyled, SectionBodyStyled }
